// TODO: This file contain types that also exported from @wix/blocks-widget-services-types
// But since it's private package, we should find way how to use it from there.
// One option would be to bundle types from it into resulted file with types.

export type PropsChangedHandler<T> = (oldProps: T, newProps: T) => void;

export interface $Widget<
  T extends object,
  E extends Record<string, any> = Record<string, any>,
> {
  props: T;
  onPropsChanged: (cb: PropsChangedHandler<T>) => void;
  fireEvent: <P extends object>(
    eventName: keyof E,
    data: E[keyof E] | P,
  ) => void;
}

export interface $W<T = Record<string, any>> {
  <P extends keyof T>(selector: P): T[P];
  on: (eventName: string, cb: Function) => void;
  of: (eventName: string, cb: Function) => void;
  once: (eventName: string, cb: Function) => void;
  fireEvent: (eventName: string, event: unknown) => void;
  onReady: (cb: Function) => void;
  at: (...args: unknown[]) => $W;
  createEvent: (eventType: string, payload: object) => unknown;
}
